// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import EmojiPickerController from "./emoji_picker_controller"
application.register("emoji-picker", EmojiPickerController)

import RegisterTimeController from "./register_time_controller"
application.register("register-time", RegisterTimeController)

import TrixToolbarController from "./trix_toolbar_controller"
application.register("trix-toolbar", TrixToolbarController)

import PreviewGithubCommentController from "./preview_github_comment_controller"
application.register("preview-github-comment", PreviewGithubCommentController)

import RepositoryModalController from "./repository_modal_controller"
application.register("repository-modal", RepositoryModalController)

import VariableModalController from "./variable_modal_controller"
application.register("variable-modal", VariableModalController)

import ServerCostController from "./server_cost_controller"
application.register("server-cost", ServerCostController)
